import { saveAs } from "file-saver";
import { json2csvAsync } from "json-2-csv";

interface DownloadJSONToCSVProps {
    json: ReadonlyArray<object>;
    filename: string;
}

export const jsonToCsvString = (json: ReadonlyArray<object>): Promise<string> =>
    json2csvAsync([...json], {
        checkSchemaDifferences: true,
        emptyFieldValue: ""
    });

export const downloadJSONToCSV = async ({
    json,
    filename
}: DownloadJSONToCSVProps) => {
    const csvString = await jsonToCsvString(json);
    downloadCsv(csvString, filename);
};

export const downloadCsv = async (csv: string, filename: string) => {
    // Create a Blob and generate a URL for the CSV data
    const blob = new Blob([csv], { type: "text/csv" });
    saveAs(blob, filename);
};
